export default __webpack_public_path__ + "static/media/closed_beta.ea3b9cbd.png";